import { render, staticRenderFns } from "./SystemSpecification.vue?vue&type=template&id=14af9a15&"
import script from "./SystemSpecification.vue?vue&type=script&lang=js&"
export * from "./SystemSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports